/**
 * @fileoverview SwitchMessage — small inline "Switched to <agent-avatar>
 * <agent-name>" indicator rendered between assistant turns to flag a
 * model/persona handoff (e.g. "Developer Assist" → "AIP Assist").
 *
 * Foundry mapping: `aip-assist-impl__switch-message` with a nested
 * `__avatar __small` chip.
 */

import type { ReactElement, ReactNode } from "react";

interface Props {
  /** Avatar node — usually a small <img> or a Blueprint Icon. */
  avatar: ReactNode;
  agentName: string;
  className?: string;
}

export function SwitchMessage({ avatar, agentName, className }: Props): ReactElement {
  return (
    <div data-testid="switch-message" className={["bp-aip-switch-message", className].filter(Boolean).join(" ")}>
      Switched to <span className="bp-aip-avatar bp-aip-avatar--sm">{avatar}</span>
      {agentName}
    </div>
  );
}
